import { useState,useEffect } from "react"
import {
  BarChart,
  Bar,
  PieChart,
  Pie,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Cell,
} from "recharts"

import { Clock, Upload, Users, Activity } from "lucide-react"
import SearchHistory from "./SearchHistory"
import API_BASE_URL from "./Config"
import Cookies from "js-cookie"





const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042", "#8884d8"]

export default function Dashboard() {
    const [LoginHistory,setLoginHistory] = useState(null);
    const [totalUsers,setTotalUsers] = useState(null);
    const [totalVideos,setTotalVideos] = useState(null);
    const [loginTimeData,setLoginTimeData] = useState(null);
    const [peakHour,setPeakHour] = useState(null);
    const [deviceData,setDeviceData] = useState([]);
    const [videosByProduct,setVideosByProduct] = useState([]);
    const [recentUploads,setRecentUploads] = useState([]);
    const [recentLogins,setRecentLogins] = useState([]);
    const [todaysLogin,setTodaysLogin] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [showModal2, setShowModal2] = useState(false);
    const [loading, setLoading] = useState(false);
  

    const [videos,setVideos] = useState(null);

    const handleModalToggle = () => {
        setShowModal(!showModal);
    }

    const handleModalToggle2 = () => {
        setShowModal2(!showModal2);
    }

    useEffect(() => {
        const fetchData = async () => {
            try {
                const loginResponse = await fetch(API_BASE_URL+'GetLogin',{headers:{"Authorization": `Bearer ${Cookies.get("token")}`,}});
                if (!loginResponse.ok) throw new Error('Failed to fetch login history');
                const loginData = await loginResponse.json();
                setLoginHistory(loginData.loginHistories);
                setRecentLogins(loginData.loginHistories);
                const todaysLogin = getTodaysLogin(loginData.loginHistories);
                setTodaysLogin(todaysLogin);
                const { chartData, peakHour } = prepareLoginActivityByHour(loginData.loginHistories);
                setPeakHour(peakHour);
                setLoginTimeData(chartData);
                
                const deviceCounts = countDeviceTypes(loginData.loginHistories);
                setDeviceData(deviceCounts);     
                
                const uniqueCustomerIds = new Set(loginData.loginHistories.map(item=>item.customerId));
                const uniqueCustomerCount = uniqueCustomerIds.size;
                setTotalUsers(uniqueCustomerCount);

                const videoResponse = await fetch(API_BASE_URL+'videos',{headers:{"Authorization": `Bearer ${Cookies.get("token")}`,}});
                if (!videoResponse.ok) throw new Error('Failed to fetch videos');
                
                const videoData = await videoResponse.json();
                const videos = videoData.videos ?? [];
                setVideos(videos); 
                setRecentUploads(videos); 

                if (videos.length > 0) {
                  const uniqueProductVideos = new Set(videos.map(item => item.productName));
                  const videosByProductCounts = Array.from(uniqueProductVideos).map(product => {
                      return {
                          name: product,
                          value: videos.filter(item => item.productName === product).length,
                      };
                  });
                  setVideosByProduct(videosByProductCounts);          

                  const uniqueVideoIds = new Set(videos.map(item => item.videoId));
                  setTotalVideos(uniqueVideoIds.size);
              } else {
                  setVideosByProduct([]);
                  setTotalVideos(0);
              }
     
            } catch (error) {
              console.error("Fetch error:", error);
            }
        };
        fetchData();
    }, []);

    useEffect(() => {
      if (showModal && window.Tabulator) {
        setTimeout(() => {
          const table = new window.Tabulator("#logins-table", {
            data: recentLogins,
            layout: "fitColumns",
            theme: "modern",
            height: "auto",
          pagination: "local",
          paginationSize: 5,
          paginationButtonCount: 5,
            columns: [
              { 
                title: "No.", 
                formatter: "rownum", 
                hozAlign: "center", 
                width: 70, 
                headerSort: false, 
                resizable: false 
              },
              { title: "User", field: "customerName",hozAlign: "center",},
              {
                title: "Date",
                field: "loginDateTime",
                formatter: (cell) => new Date(cell.getValue()).toLocaleString(),
                resizable: false,
                hozAlign: "center",
              },
              { title: "IP Address", field: "iP_Address", resizable: false,hozAlign: "center",},
              { title: "Device", field: "device_Type", resizable: false, hozAlign: "center",},
            ],
          });
    
          return () => table.destroy();
        }, 100); 
      }
    }, [showModal, recentLogins]);

    useEffect(() => {
      if (showModal2 && window.Tabulator) {
        setTimeout(() => {
          const table = new window.Tabulator("#uploads-table", {
            data: recentUploads,
            layout: "fitColumns",
            height: "auto",
            pagination: "local",
            paginationSize: 5,
            paginationButtonCount: 5,
            theme: "modern",
            columns: [
              { 
                title: "No.", 
                formatter: "rownum", 
                hozAlign: "center", 
                width: 70, 
                headerSort: false, 
                resizable: false 
              },
              { title: "Title", field: "title" ,hozAlign: "center",},
              { title: "Product", field: "productName",hozAlign: "center", },
              {
                title: "Date",
                field: "uploadedAt",
                formatter: (cell) => new Date(cell.getValue()).toLocaleString(),
                resizable: false,
                hozAlign: "center",
              },
            ],
          });
      
          return () => table.destroy();
        }, 100); 
      }
    }, [showModal2, recentUploads]);
    

    const getTodaysLogin = (loginHistories) =>{
      const today = new Date();

      const count = loginHistories.filter(entry => {
          const loginDate = new Date(entry.loginDateTime);
          return loginDate.getDate() === today.getDate() &&
                 loginDate.getMonth() === today.getMonth() &&
                 loginDate.getFullYear() === today.getFullYear();
      }).length;
      return count;
    }

    const prepareLoginActivityByHour = (loginHistories) => {
        const hourSlots = [
            "00:00", "03:00", "06:00", "09:00", "12:00", "15:00", "18:00", "21:00"
        ];
    
        const slotCounts = {};
        hourSlots.forEach(slot => {
            slotCounts[slot] = 0;
        });
    
        loginHistories.forEach(entry => {
            const loginDate = new Date(entry.loginDateTime);
            const hour = loginDate.getHours();

            const roundedHour = Math.floor(hour / 3) * 3;
            const slot = `${roundedHour.toString().padStart(2, '0')}:00`;
    
            slotCounts[slot] += 1;
        });

        const chartData = hourSlots.map(slot => ({
            hour: slot,
            logins: slotCounts[slot]
        }));
    
        const peakHourEntry = chartData.reduce((prev, curr) => curr.logins > prev.logins ? curr : prev, chartData[0]);
    
        return {
            chartData,
            peakHour: peakHourEntry.hour,
        };
    };

    const countDeviceTypes = (loginHistories) => {
      const counts = {};

    loginHistories.forEach(entry => {
        const type = entry.device_Type || "Unknown";
        counts[type] = (counts[type] || 0) + 1;
    });

    const deviceData = Object.keys(counts).map(key => ({
        name: key,
        value: counts[key],
    }));

    return deviceData;
  };
  
    

  return (
    <>
    <div className="container-fluid p-0">
      
      {/* Main Content */}
      <div className="container-fluid py-4 px-4 bg-light min-vh-100">
        {/* Summary Cards */}
        <div className="row g-4 mb-4">
          <div className="col-md-3">
            <div className="card border-0 shadow-sm h-100">
              <div className="card-body d-flex align-items-center">
                <div className="rounded-circle bg-primary bg-opacity-10 p-3 me-3">
                  <Users className="text-primary" size={24} />
                </div>
                <div>
                  <h6 className="card-subtitle mb-1 text-muted">Total Users</h6>
                  <h3 className="card-title mb-0">{totalUsers}</h3>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="card border-0 shadow-sm h-100">
              <div className="card-body d-flex align-items-center">
                <div className="rounded-circle bg-success bg-opacity-10 p-3 me-3">
                  <Upload className="text-success" size={24} />
                </div>
                <div>
                  <h6 className="card-subtitle mb-1 text-muted">Videos Uploaded</h6>
                  <h3 className="card-title mb-0">{totalVideos}</h3>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="card border-0 shadow-sm h-100">
              <div className="card-body d-flex align-items-center">
                <div className="rounded-circle bg-warning bg-opacity-10 p-3 me-3">
                  <Clock className="text-warning" size={24} />
                </div>
                <div>
                  <h6 className="card-subtitle mb-1 text-muted">Peak Login Time</h6>
                  <h3 className="card-title mb-0">{peakHour}</h3>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="card border-0 shadow-sm h-100">
              <div className="card-body d-flex align-items-center">
                <div className="rounded-circle bg-info bg-opacity-10 p-3 me-3">
                  <Activity className="text-info" size={24} />
                </div>
                <div>
                  <h6 className="card-subtitle mb-1 text-muted">Today's Logins</h6>
                  <h3 className="card-title mb-0">{todaysLogin}</h3>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Charts Row */}
        <div className="row g-4 mb-4">
          <div className="col-md-8">
            <div className="card border-0 shadow-sm">
              <div className="card-header bg-white border-0">
                <h5 className="card-title mb-0">Login Activity by Time</h5>
              </div>
              <div className="card-body">
                <ResponsiveContainer width="100%" height={300}>
                  <BarChart data={loginTimeData}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="hour" />
                    <YAxis />
                    <Tooltip />
                    <Legend />
                    <Bar dataKey="logins" name="Login Count" fill="#4e73df" />
                  </BarChart>
                </ResponsiveContainer>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card border-0 shadow-sm">
              <div className="card-header bg-white border-0">
                <h5 className="card-title mb-0">Device Usage</h5>
              </div>
              <div className="card-body">
                <ResponsiveContainer width="100%" height={300}>
                  <PieChart>
                    <Pie
                      data={deviceData}
                      cx="60%"
                      cy="50%"
                      labelLine={false}
                      outerRadius={80}
                      fill="#8884d8"
                      dataKey="value"
                      label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
                    >
                      {deviceData.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                      ))}
                    </Pie>
                    <Tooltip />
                  </PieChart>
                </ResponsiveContainer>
              </div>
            </div>
          </div>
        </div>

        {/* Geo Distribution and Videos by Product */}
        <div className="row g-4 mb-4">
          <div className="col-md-8">
            <div className="card border-0 shadow-sm">

              <div className="card-body">
                       
                  <SearchHistory data={LoginHistory} />
                
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card border-0 shadow-sm">
              <div className="card-header bg-white border-0">
                <h5 className="card-title mb-0">Videos by Product</h5>
              </div>
              <div className="card-body">
              {videosByProduct.length > 0 ? (
                <ResponsiveContainer width="100%" height={400}>
                  <BarChart
                    data={videosByProduct}
                    layout="vertical"
                    margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
                  >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis type="number" />
                    <YAxis dataKey="name" type="category" width={80} />
                    <Tooltip />
                    <Legend />
                    <Bar dataKey="value" name="Videos" fill="#82ca9d" />
                  </BarChart>
                </ResponsiveContainer>
              ) : (
                <div className="text-center text-muted" style={{ height: 400, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  No videos available
                </div>
              )}
              </div>
            </div>
          </div>
        </div>

        {/* Recent Uploads and Logins */}
        <div className="row g-4">
          <div className="col-md-6">
            <div className="card border-0 shadow-sm rounded">
              <div className="card-header bg-white border-0 d-flex justify-content-between align-items-center">
                <h5 className="card-title mb-0">Recent Logins</h5>
                <button type="button" className="btn btn-sm btn-primary" onClick={handleModalToggle}>
                  View All
                </button>
              </div>
              <div className="card-body p-0 rounded">
              <div className="table-responsive">
                  <table className="table table-hover mb-0">
                    <thead className="table-light">
                      <tr>
                        <th>User</th>
                        <th>Date</th>
                        <th>IP Address</th>
      
                        <th>Device</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(recentLogins ?? [])
                          .sort((a, b) => new Date(b.loginDateTime) - new Date(a.loginDateTime))
                          .slice(0, 5)
                          .map((login) => (
                            <tr key={login.loginId}>
                              <td>{login.customerName}</td>
                              <td>{new Date(login.loginDateTime).toLocaleString()}</td>
                              <td>{login.iP_Address}</td>
                              <td>{login.device_Type}</td>
                            </tr>
                          ))}

                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="card border-0 shadow-sm">
              <div className="card-header bg-white border-0 d-flex justify-content-between align-items-center">
                <h5 className="card-title mb-0">Recent Uploads</h5>
                <button className="btn btn-sm btn-primary text-decoration-none" onClick={handleModalToggle2}>
                  View All
                </button>
              </div>
              <div className="card-body p-0">
              <div className="table-responsive">
                  <table className="table table-hover mb-0">
                    <thead className="table-light">
                      <tr>
                        <th>Title</th>
                        <th>Product</th>
                        <th>Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(recentUploads ?? []).length > 0 ? (
                        recentUploads
                          .sort((a, b) => new Date(b.uploadedAt) - new Date(a.uploadedAt))
                          .slice(0, 5)
                          .map((upload) => (
                            <tr key={upload.videoId}>
                              <td>{upload.title}</td>
                              <td>{upload.productName}</td>
                              <td>{new Date(upload.uploadedAt).toLocaleString()}</td>
                            </tr>
                          ))
                      ) : (
                        <tr>
                          <td colSpan="3" className="text-center text-muted">
                            No recent uploads available
                          </td>
                        </tr>
                      )}

                    </tbody>

                  </table>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

      
    </div>
    {
      showModal && (
        <div
          className="modal modal-lg fade show d-block"
          tabIndex="-1"
          style={{ background: "rgba(0,0,0,0.5)" }}
        >
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="modal-header bg-primary text-white">
                  <h5 className="modal-title" id="exampleModalLongTitle">Login History</h5>
                  <button
                  className="btn-close"
                  onClick={handleModalToggle}
                ></button>
                </div>
                <div className="modal-body">
                <div id="logins-table" className="mt-3"></div>

                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-danger" data-dismiss="modal" onClick={handleModalToggle}>Close</button>
                </div>
              </div>
            </div>
          </div>
      )
    }


{
      showModal2 && (
        <div
          className="modal modal-lg fade show d-block"
          tabIndex="-1"
          style={{ background: "rgba(0,0,0,0.5)" }}
        >
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="modal-header bg-primary text-white">
                  <h5 className="modal-title" id="exampleModalLongTitle">Upload History</h5>
                  <button
                  className="btn-close"
                  onClick={handleModalToggle2}
                ></button>
                </div>
                <div className="modal-body">
                <div id="uploads-table" className="mt-3"></div>

                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-danger" data-dismiss="modal" onClick={handleModalToggle2}>Close</button>
                </div>
              </div>
            </div>
          </div>
      )
    }
    
    </>
  )
}